import React from 'react';
import { TimeConverter } from './components/features/time-converter';
import './styles/globals.css';

function App() {
  return (
    <div className="min-h-screen bg-background text-foreground">
      <TimeConverter />
    </div>
  );
}

export default App; 